if (!customElements.get('hanmade-hero')) {
  customElements.define('hanmade-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('.hb-hero-panel')];
      this.activate = (panel) => {
        this.panels.forEach(item => {
          const active = item === panel;
          item.classList.toggle('is-active', active);
          item.querySelector('button').setAttribute('aria-expanded', String(active));
          item.querySelector('.hb-hero-detail').hidden = !active;
        });
      };
      this.panels.forEach(panel => {
        panel.querySelector('button').addEventListener('click', () => this.activate(panel), options);
        panel.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' && matchMedia('(min-width: 1100px) and (hover: hover)').matches && !this.contains(document.activeElement)) this.activate(panel);
        }, options);
        panel.addEventListener('click', event => {
          if (event.target.closest('a, button')) return;
          if (matchMedia('(min-width: 1100px) and (hover: hover)').matches && event.pointerType === 'mouse') {
            const link = panel.querySelector('a');
            if (link) link.click();
          } else this.activate(panel);
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('.hb-hero-panel');
        if (panel) this.activate(panel);
      }, options);
      if (this.panels.length) this.activate(this.panels[0]);
      this.dataset.ready = '';
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
